

export function serializeQuery(query) {
    return {
        ...query,
        // companies: query?.companies?.map(company => company.id ?? company),
    }
}

export function parseQuery(query) {
    return {
        ...query,
        companies: [].concat(query.companies ?? []).map(id => Number(id)),
        artisticFields: [].concat(query.artisticFields ?? []).map(id => Number(id)),
    }
}